export function preloadImages(urlList: string[]) {
  return urlList.map((image) => {
    const img = new Image();
    img.src = image;

    return img;
  });
}
